import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input} from '@progress/kendo-react-inputs';
import {DropDownList } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import ReactFileReader from 'react-file-reader';
import { Switch } from '@progress/kendo-react-inputs';
import '@progress/kendo-react-common'
import '@progress/kendo-date-math'
import './ManagePurchaseAndRenewals.scss';
import {
	getTransactionDetails
	
} from '../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';
import { ROOT_API_URL } from '../../../../../api-config';
import { auth} from '../../../../../services';
import axios from 'axios';

class PurchaseAndRenewalDetailsForm extends Component {
	constructor(props) {
        super(props);
		this.state = {
			transactionInEdit: this.props.dataItem || null,			
            value: [],
        };
    };
    componentDidMount() {
		var url = `${ROOT_API_URL}/ManageTransaction/GetTransactionDetails?transactionId=${this.state.transactionInEdit.TransactionId}`;
    // console.log(url);
		const options = { method: 'GET', headers: auth.authHeader() };
		axios
			.get(url, options)
			.then((res) => {
                console.log(res.data, "transaction details")
				this.setState({
					transactionInEdit: res.data
				})
			})
    }

 
	render() {
        console.log(this.state.transactionInEdit.TransactionDetails, "transaction details1")
		return (
		<div className="eventDialog transactionEditPopup">
            <Dialog onClose={this.props.cancel}>
               
                <h2 className="adjust-title">Transaction Details</h2>    
				<form className="user-form ordersForm" onSubmit={this.handleSubmit}>
                    <div className="form-group col-md-7 col-lg-7">
                        <label htmlFor="title">TransactionId: {this.state.transactionInEdit.transactionId}</label>
                    </div>
                    <div className="form-group col-md-7 col-lg-7">
                        {this.state.transactionInEdit.transactionDetails ? 
                            <ul className="editProductList">
                                {
                                this.state.transactionInEdit.transactionDetails.map((item, index) => {
                                        if (item.productDetails !== null) {
                                            return (
                                                <ul className="orderList">
                                                    <li>{item.description}</li>
                                                    {item.productDetails.map((product, key) => {
                                                        return (
                                                            <li className="purchaseListItem" key={key}>
                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        {product.description}
                                                                    </div>
                                                                    <div className="col-md-4 right">
                                                                        <p>${product.quantity}</p>
                                                                    </div>
                                                                    <div className="col-md-4 right">
                                                                        <p>${product.amount}</p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            )
                                        } else {
                                            return (
                                                <li className="purchaseListItem" key={index}>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            {item.description}
                                                        </div>
                                                        <div className="col-md-4 right">
                                                            <p>${item.quantity}</p>
                                                        </div>
                                                        <div className="col-md-4 right">
                                                            <p>${item.amount}</p>
                                                        </div>
                                                    </div>
                                                </li>
                                            )
                                        }
                                    })
                                }
                            </ul> 
                        : "" }
                    </div>
                    <hr />                            
                    <div className="form-group col-md-7 col-lg-7">
                        <label htmlFor="title">Total Amount: {this.state.transactionInEdit.subTotal}</label>
                    </div>
                    <div className="form-group col-md-7 col-lg-7">
                        <label htmlFor="title">Tax: {this.state.transactionInEdit.tax}</label>
                    </div>
                    <div className="form-group col-md-7 col-lg-7">
                        <label htmlFor="title">Grand Total: {this.state.transactionInEdit.grandTotal}</label>
                    </div>
                    <DialogActionsBar>
                        <div>
                            <div className="form-group">
                                <button className="admin-k-button" onClick={this.props.cancel}>
                                    <i className="fas fa-times"></i>
                                    <span>CANCEL</span>
                                </button>
                            </div>
                        </div>
                    </DialogActionsBar>
				</form>
			</Dialog>
		</div>
		);
    }
}
 
 function mapStateToProps(state) {
	return {
        common: state.common,
        purchaseAndRenewals: state.purchaseAndRenewals
	};
}

export default connect(mapStateToProps, {getTransactionDetails,auth})(PurchaseAndRenewalDetailsForm);
